export const LOCALE = '333f-locale-lang'
export const LANG_EN = 'us_en'
export const LANG_CN = 'zh_cn'



// WEBPACK FOOTER //
// ./src/js/local-name.js